import { useMemo } from "react";

import { useGlobalStoreContext } from "@/context/globalStoreContext";

export const useProInfo = () => {
  const store = useGlobalStoreContext();

  return useMemo(() => {
    return {
      isPro: Number(store.user_type) === 1,
      isProFromCache: Number(store.persistStore?.user_type) === 1,
    };
  }, [store]);
};
